/**-----------------------------------------------------------------------------------------
* Copyright © 2021 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the project root for more information
*-------------------------------------------------------------------------------------------*/
import { __decorate, __metadata, __param } from 'tslib';
import { EventEmitter, ViewChild, ViewContainerRef, Input, TemplateRef, HostBinding, Component, ChangeDetectorRef, ElementRef, Renderer2, ComponentFactoryResolver, InjectionToken, ApplicationRef, Injectable, Inject, Optional, Injector, Directive, forwardRef, NgModule } from '@angular/core';
import { style, animate, AnimationBuilder } from '@angular/animations';
import { take } from 'rxjs/operators';
import { validatePackage } from '@progress/kendo-licensing';
import { LocalizationService, L10N_PREFIX, ComponentMessages } from '@progress/kendo-angular-l10n';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/animations';
import * as ɵngcc2 from '@progress/kendo-angular-l10n';
import * as ɵngcc3 from '@angular/common';

const _c0 = ["container"];
function NotificationComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 9);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.typeIconClass());
} }
function NotificationComponent_ng_template_5_Template(rf, ctx) { }
function NotificationComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.templateString, " ");
} }
function NotificationComponent_a_9_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 10);
    ɵngcc0.ɵɵlistener("click", function NotificationComponent_a_9_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r5.onCloseClick()); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("title", ctx_r4.closeButtonTitle);
} }
const _c3 = ["group"];
class NotificationSettings {
    constructor() {
        /**
         * Specifies the time in milliseconds after which the
         * Notification will hide
         * ([see example]({% slug hiding_notifications %}#toc-definig-a-delay-before-hiding)).
         * Defaults to `5000`.
         */
        this.hideAfter = 5000;
        /**
         * Defines the position of the Notification
         * ([see example]({% slug positioning_notification %})).
         *
         * The possible values are:
         * * `horizontal: 'left'|'center'|'right'`
         * * `vertical: 'top'|'bottom'`
         */
        this.position = { horizontal: 'right', vertical: 'top' };
        /**
         * Specifies the animation settings of the Notification
         * ([see example]({% slug animations_notification %})).
         *
         * The possible values are:
         * * `duration`&mdash;Accepts a number in milliseconds. Defaults to `500ms`.
         * * `type?: 'slide'| (Default) 'fade'`
         */
        this.animation = { type: 'fade', duration: 500 };
        /**
         * Specifies if the Notification will require a user action to hide.
         * If the property is set to `true`, the Notification renders a **Close** button
         * ([see example]({% slug hiding_notifications %}#toc-defining-a-closable-notification)).
         *
         * The possible values are:
         * * (Default) `false`
         * * `true`
         */
        this.closable = false;
        /**
         * Specifies the type of the Notification
         * ([see example]({% slug types_notification %})).
         *
         * The possible values are:
         * * `style: (Default) 'none'|'success'|'error'|'warning'|'info'`
         * * `icon: 'true'|'false'`
         */
        this.type = { style: 'none', icon: true };
    }
}

/**
 * @hidden
 */
const packageMetadata = {
    name: '@progress/kendo-angular-notification',
    productName: 'Kendo UI for Angular',
    productCodes: ['KENDOUIANGULAR', 'KENDOUICOMPLETE'],
    publishDate: 1646219065,
    version: '',
    licensingDocsUrl: 'https://www.telerik.com/kendo-angular-ui/my-license/?utm_medium=product&utm_source=kendoangular&utm_campaign=kendo-ui-angular-purchase-license-keys-warning'
};

/**
 * @hidden
 */
function slideAnimation(height, duration) {
    return [
        style({ overflow: 'hidden', height: 0 }),
        animate(`${duration}ms ease-in`, style({ height: `${height}px` }))
    ];
}
/**
 * @hidden
 */
function slideCloseAnimation(height, duration) {
    return [
        style({ height: `${height}px` }),
        animate(`${duration}ms ease-in`, style({ overflow: 'hidden', height: 0 }))
    ];
}
/**
 * @hidden
 */
function fadeAnimation(duration) {
    return [
        style({ opacity: 0 }),
        animate(`${duration}ms ease-in`, style({ opacity: 1 }))
    ];
}
/**
 * @hidden
 */
function fadeCloseAnimation(duration) {
    return [
        style({ opacity: 1 }),
        animate(`${duration}ms ease-in`, style({ opacity: 0 }))
    ];
}

/**
 * @hidden
 *
 */
let NotificationComponent = class NotificationComponent {
    constructor(cdr, element, renderer, builder, localizationService) {
        this.cdr = cdr;
        this.element = element;
        this.renderer = renderer;
        this.builder = builder;
        this.localizationService = localizationService;
        this.close = new EventEmitter();
        this.width = null;
        this.height = null;
        this.defaultHideAfter = 5000;
        this.animationEnd = new EventEmitter();
        this.rtl = false;
        validatePackage(packageMetadata);
        this.dynamicRTLSubscription = localizationService.changes.subscribe(({ rtl }) => {
            this.rtl = rtl;
            this.direction = this.rtl ? 'rtl' : 'ltr';
        });
    }
    get containerClass() {
        return true;
    }
    get closeButtonTitle() {
        return this.closeTitle || this.localizationService.get('closeTitle');
    }
    notificationClasses() {
        return `${this.type ? this.typeClass() : ''}
            ${this.closable ? 'k-notification-closable' : ''}`;
    }
    ngOnInit() {
        clearTimeout(this.hideTimeout);
    }
    ngOnDestroy() {
        clearTimeout(this.hideTimeout);
        if (this.dynamicRTLSubscription) {
            this.dynamicRTLSubscription.unsubscribe();
        }
    }
    ngAfterViewInit() {
        if (!this.closable && !this.animation) {
            this.setHideTimeout();
        }
        if (!this.closable && this.animation) {
            this.animationEnd.pipe(take(1))
                .subscribe(() => this.setHideTimeout());
        }
        if (this.animation) {
            this.animate(this.animation);
        }
    }
    typeClass() {
        return {
            'none': '',
            'success': 'k-notification-success',
            'warning': 'k-notification-warning',
            'error': 'k-notification-error',
            'info': 'k-notification-info'
        }[this.type.style];
    }
    typeIconClass() {
        return {
            'none': '',
            'success': 'k-i-success',
            'warning': 'k-i-warning',
            'error': 'k-i-error',
            'info': 'k-i-info'
        }[this.type.style];
    }
    onCloseClick() {
        clearTimeout(this.hideTimeout);
        this.hide();
    }
    hide(customComponent) {
        const elementHeight = getComputedStyle(this.element.nativeElement).height;
        if (this.animation && elementHeight) {
            this.animate(this.animation, true);
            this.animationEnd.subscribe(() => {
                this.emitClose(customComponent);
            });
            return;
        }
        this.emitClose(customComponent);
    }
    setHideTimeout() {
        const hideAfter = this.hideAfter || this.defaultHideAfter;
        this.hideTimeout = window.setTimeout(() => this.onCloseClick(), hideAfter);
    }
    emitClose(customComponent) {
        if (customComponent) {
            customComponent.destroy();
        }
        this.close.emit();
    }
    play(animation, animatedElement) {
        const factory = this.builder.build(animation);
        const element = this.element.nativeElement;
        this.renderer.addClass(element, 'k-notification-container-animating');
        let player = factory.create(animatedElement);
        player.onDone(() => {
            this.renderer.removeClass(element, 'k-notification-container-animating');
            this.animationEnd.emit();
            if (player) {
                player.destroy();
                player = null;
            }
        });
        player.play();
    }
    animate(animation, onclose) {
        const element = this.element.nativeElement;
        const duration = animation.duration;
        const height = element.offsetHeight;
        const generatedAnimation = animation.type === 'slide' ?
            this.slideAnimation(height, duration, onclose) :
            this.fadeAnimation(duration, onclose);
        this.play(generatedAnimation, element);
    }
    slideAnimation(height, duration, onclose) {
        return onclose ? slideCloseAnimation(height, duration) : slideAnimation(height, duration);
    }
    fadeAnimation(duration, onclose) {
        return onclose ? fadeCloseAnimation(duration) : fadeAnimation(duration);
    }
};
NotificationComponent.ɵfac = function NotificationComponent_Factory(t) { return new (t || NotificationComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.AnimationBuilder), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.LocalizationService)); };
NotificationComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NotificationComponent, selectors: [["kendo-notification"]], viewQuery: function NotificationComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 7, ViewContainerRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.container = _t.first);
    } }, hostVars: 3, hostBindings: function NotificationComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("dir", ctx.direction);
        ɵngcc0.ɵɵclassProp("k-notification-container", ctx.containerClass);
    } }, inputs: { width: "width", height: "height", templateRef: "templateRef", templateString: "templateString", cssClass: "cssClass", hideAfter: "hideAfter", closable: "closable", type: "type", animation: "animation" }, features: [ɵngcc0.ɵɵProvidersFeature([
            LocalizationService,
            {
                provide: L10N_PREFIX,
                useValue: 'kendo.notification'
            }
        ])], decls: 10, vars: 13, consts: function () { let i18n_1; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the close button
         * @meaning kendo.notification.closeTitle
         */
        const MSG_EXTERNAL_2647775058951488820$$DIST_FESM2015_INDEX_JS_2 = goog.getMsg("Close");
        i18n_1 = MSG_EXTERNAL_2647775058951488820$$DIST_FESM2015_INDEX_JS_2;
    }
    else {
        i18n_1 = $localize `:kendo.notification.closeTitle|The title of the close button␟ec4f6e0c77992a6dd3518cec396079fd0bd06d53␟2647775058951488820:Close`;
    } return [["kendoNotificationLocalizedMessages", "", "closeTitle", i18n_1], [3, "ngClass"], [1, "k-notification-wrap", "k-hstack"], ["class", "k-icon", 3, "ngClass", 4, "ngIf"], [1, "k-notification-content"], [3, "ngIf", "ngTemplateOutlet"], [3, "ngIf"], ["container", ""], ["class", "k-icon k-i-close", 3, "click", 4, "ngIf"], [1, "k-icon", 3, "ngClass"], [1, "k-icon", "k-i-close", 3, "click"]]; }, template: function NotificationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainer(0, 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1)(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, NotificationComponent_span_3_Template, 1, 1, "span", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵtemplate(5, NotificationComponent_ng_template_5_Template, 0, 0, "ng-template", 5);
        ɵngcc0.ɵɵtemplate(6, NotificationComponent_ng_template_6_Template, 1, 1, "ng-template", 6);
        ɵngcc0.ɵɵelementContainer(7, null, 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, NotificationComponent_a_9_Template, 1, 1, "a", 8);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate1("k-widget k-notification ", ctx.notificationClasses(), "");
        ɵngcc0.ɵɵstyleProp("height", ctx.height, "px")("width", ctx.width, "px");
        ɵngcc0.ɵɵproperty("ngClass", ctx.cssClass);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.type && ctx.type.icon && ctx.type.style !== "none");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.templateRef)("ngTemplateOutlet", ctx.templateRef);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.templateString);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.closable);
    } }, dependencies: function () { return [ɵngcc3.NgClass, ɵngcc3.NgIf, ɵngcc3.NgTemplateOutlet, LocalizedMessagesDirective]; }, encapsulation: 2 });
__decorate([
    ViewChild('container', { read: ViewContainerRef, static: true }),
    __metadata("design:type", ViewContainerRef)
], NotificationComponent.prototype, "container", void 0);
__decorate([
    Input(),
    __metadata("design:type", TemplateRef)
], NotificationComponent.prototype, "templateRef", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], NotificationComponent.prototype, "templateString", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], NotificationComponent.prototype, "width", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], NotificationComponent.prototype, "height", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], NotificationComponent.prototype, "cssClass", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], NotificationComponent.prototype, "hideAfter", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NotificationComponent.prototype, "closable", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], NotificationComponent.prototype, "type", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], NotificationComponent.prototype, "animation", void 0);
__decorate([
    HostBinding('attr.dir'),
    __metadata("design:type", String)
], NotificationComponent.prototype, "direction", void 0);
__decorate([
    HostBinding('class.k-notification-container'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], NotificationComponent.prototype, "containerClass", null);
NotificationComponent = __decorate([ __metadata("design:paramtypes", [ChangeDetectorRef,
        ElementRef,
        Renderer2,
        AnimationBuilder,
        LocalizationService])
], NotificationComponent);

/**
 * @hidden
 *
 */
let NotificationContainerComponent = class NotificationContainerComponent {
    constructor(element, renderer, resolver) {
        this.element = element;
        this.renderer = renderer;
        this.resolver = resolver;
        this.id = '';
        this.notifications = [];
    }
    ngOnDestroy() {
        this.notifications.forEach((notification) => {
            if (notification.closeClickSubscription) {
                notification.closeClickSubscription.unsubscribe();
            }
        });
        this.notifications = [];
    }
    addNotification(settings) {
        this.position = settings.position;
        this.id = `${this.position.horizontal} ${this.position.vertical}`;
        const factory = this.resolver.resolveComponentFactory(NotificationComponent);
        const notificationRef = this.container.createComponent(factory);
        this.applySettings(notificationRef, settings);
        let customComponent = null;
        if (typeof settings.content === 'function') {
            const customFactory = this.resolver.resolveComponentFactory(settings.content);
            customComponent = notificationRef.instance.container.createComponent(customFactory);
        }
        notificationRef.changeDetectorRef.detectChanges();
        this.notifications.push(notificationRef.instance);
        if (settings.appendTo) {
            this.applyAbsolutePosition(settings.appendTo);
        }
        this.applyPosition();
        this.applyContainerWrap();
        return {
            afterHide: notificationRef.instance.close,
            hide: () => notificationRef.instance.hide(customComponent),
            notification: notificationRef,
            content: customComponent || null
        };
    }
    hide(notificationRef) {
        const instance = notificationRef.instance;
        const index = this.notifications.indexOf(instance);
        this.notifications.splice(index, 1);
        if (instance.closeClickSubscription) {
            instance.closeClickSubscription.unsubscribe();
        }
        instance.templateRef = null;
        instance.templateString = null;
        notificationRef.destroy();
    }
    applyContainerWrap() {
        const value = this.position.horizontal === 'right' ? 'wrap-reverse' : 'wrap';
        this.renderer.setStyle(this.group.nativeElement, 'flex-wrap', value);
    }
    applySettings(notificationRef, settings) {
        const notification = notificationRef.instance;
        const content = settings.content;
        const animation = settings.animation || null;
        notification.closeClickSubscription = notification.close
            .subscribe(() => this.hide(notificationRef));
        if (typeof content === 'string') {
            notification.templateString = content;
        }
        if (content instanceof TemplateRef) {
            notification.templateRef = content;
        }
        notification.animation = animation;
        let type = settings.type;
        if (type && type.style === undefined) {
            type.style = 'none';
        }
        if (type && type.icon === undefined) {
            type.icon = true;
        }
        notification.type = type;
        notification.closeTitle = settings.closeTitle;
        if (settings.cssClass) {
            notification.cssClass = settings.cssClass;
        }
        notification.closable = settings.closable;
        notification.hideAfter = settings.hideAfter;
        notification.width = settings.width;
        notification.height = settings.height;
    }
    applyAbsolutePosition(appendToContainer) {
        const appendTo = appendToContainer.element.nativeElement;
        const el = this.element.nativeElement.children[0];
        if (window.getComputedStyle(appendTo).position === 'static') {
            this.renderer.setStyle(appendTo, 'position', 'relative');
        }
        this.renderer.setStyle(el, 'position', 'absolute');
    }
    applyPosition() {
        const element = this.element.nativeElement.children[0];
        const elementHalfWidth = element.getBoundingClientRect().width / 2;
        const positionStyles = this.setContainerPosition(this.position, elementHalfWidth);
        Object.keys(positionStyles).forEach((cssStyle) => {
            element.style[cssStyle] = positionStyles[cssStyle];
        });
    }
    setContainerPosition(position, offsetMargin) {
        const positionLayout = {
            horizontal: {
                left: { left: 0, alignItems: 'flex-start' },
                right: { right: 0, alignItems: 'flex-start' },
                center: { left: '50%', marginLeft: `${-offsetMargin}px`, alignItems: 'center' }
            },
            vertical: {
                top: { top: 0 },
                bottom: { bottom: 0 }
            }
        };
        const horizontal = positionLayout.horizontal[position.horizontal];
        const vertical = positionLayout.vertical[position.vertical];
        return Object.assign({}, horizontal, vertical);
    }
};
NotificationContainerComponent.ɵfac = function NotificationContainerComponent_Factory(t) { return new (t || NotificationContainerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver)); };
NotificationContainerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NotificationContainerComponent, selectors: [["kendo-notification-container"]], viewQuery: function NotificationContainerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 7, ViewContainerRef);
        ɵngcc0.ɵɵviewQuery(_c3, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.container = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.group = _t.first);
    } }, inputs: { id: "id" }, decls: 4, vars: 0, consts: [[1, "k-notification-group"], ["group", ""], ["container", ""]], template: function NotificationContainerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵelementContainer(2, null, 2);
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
__decorate([
    ViewChild('container', { read: ViewContainerRef, static: true }),
    __metadata("design:type", ViewContainerRef)
], NotificationContainerComponent.prototype, "container", void 0);
__decorate([
    ViewChild('group', { static: true }),
    __metadata("design:type", ElementRef)
], NotificationContainerComponent.prototype, "group", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], NotificationContainerComponent.prototype, "id", void 0);
NotificationContainerComponent = __decorate([ __metadata("design:paramtypes", [ElementRef,
        Renderer2,
        ComponentFactoryResolver])
], NotificationContainerComponent);

/**
 * Used to inject the Notification container. If not provided, the first root component of
 * the application is used.
 *
 * > The `NOTIFICATION_CONTAINER` can be used only with the [`NotificationService`]({% slug api_notification_notificationservice %}) class.
 *
 * @example
 *
 * ```ts-no-run
 * // Import the Notification module
 * import { NotificationModule, NOTIFICATION_CONTAINER } from '@progress/kendo-angular-notification';
 *
 * // The browser platform with a compiler
 * import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
 *
 * import { ElementRef, NgModule } from '@angular/core';
 *
 * // Import the app component
 * import { AppComponent } from './app.component';
 *
 * // Define the app module
 * _@NgModule({
 *     declarations: [AppComponent], // declare app component
 *     imports:      [BrowserModule, NotificationModule], // import Notification module
 *     bootstrap:    [AppComponent],
 *     providers: [{
 *       provide: NOTIFICATION_CONTAINER,
 *       useFactory: () => {
 *          //return the container ElementRef, where the notification will be injected
 *          return { nativeElement: document.body } as ElementRef;
 *       }
 *     }]
 * })
 * export class AppModule {}
 *
 * // Compile and launch the module
 * platformBrowserDynamic().bootstrapModule(AppModule);
 * ```
 */
const NOTIFICATION_CONTAINER = new InjectionToken('Notification Container');
/**
 * A service for opening Notification components dynamically
 * ([see example]({% slug overview_notification %})).
 *
 * @export
 * @class NotificationService
 */
let NotificationService = class NotificationService {
    /**
     * @hidden
     */
    constructor(resolver, injector, container) {
        this.resolver = resolver;
        this.injector = injector;
        this.container = container;
        this.notificationContainers = [];
        this.position = { horizontal: 'right', vertical: 'top' };
    }
    /**
     * Opens a Notification component. Created Notification are mounted
     * in the DOM directly in the root application component.
     *
     * @param {NotificationSettings} settings - The settings which define the Notification.
     *
     * @returns {NotificationRef} - A reference to the Notification object and the convenience properties.
     */
    show(settings) {
        if (!settings) {
            throw new Error('NotificationSettings settings are required');
        }
        let target = this.findGroupContainer(settings);
        const position = settings.position || this.position;
        const currentId = `${position.horizontal} ${position.vertical}`;
        let container;
        let notificationRef;
        let notificationContainer = this.notificationContainers.find(c => target.nativeElement.contains(c.element.nativeElement) && c.id === currentId);
        if (!notificationContainer) {
            container = this.resolver
                .resolveComponentFactory(NotificationContainerComponent)
                .create(this.injector);
            notificationContainer = container.instance;
            this.appRef.attachView(container.hostView);
            const hostViewElement = container.location.nativeElement;
            let groupContainer = this.findGroupContainer(settings);
            if (!groupContainer) {
                throw new Error(`
                    View Container not found! Inject the NOTIFICATION_CONTAINER or define a specific ViewContainerRef via
                    the appendTo option. See http://www.telerik.com/kendo-angular-ui/components/notification/api/NOTIFICATION_CONTAINER/
                    for more details.
                `);
            }
            groupContainer.nativeElement.appendChild(hostViewElement);
            this.notificationContainers.push(notificationContainer);
        }
        settings.position = position;
        notificationRef = notificationContainer.addNotification(settings);
        return notificationRef;
    }
    get appRef() {
        if (!this.applicationRef) {
            this.applicationRef = this.injector.get(ApplicationRef);
        }
        return this.applicationRef;
    }
    findGroupContainer(settings) {
        let container;
        if (settings.appendTo) {
            container = settings.appendTo.element;
        }
        else if (this.container) {
            container = this.container;
        }
        else {
            const appRoot = this.appRef.components && this.appRef.components[0];
            container = appRoot ? appRoot.location : null;
        }
        return container;
    }
};
NotificationService.ɵfac = function NotificationService_Factory(t) { return new (t || NotificationService)(ɵngcc0.ɵɵinject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵinject(ɵngcc0.Injector), ɵngcc0.ɵɵinject(NOTIFICATION_CONTAINER, 8)); };
NotificationService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: NotificationService, factory: function (t) { return NotificationService.ɵfac(t); } });
NotificationService = __decorate([ __param(2, Inject(NOTIFICATION_CONTAINER)), __param(2, Optional()),
    __metadata("design:paramtypes", [ComponentFactoryResolver,
        Injector,
        ElementRef])
], NotificationService);

var LocalizedMessagesDirective_1;
/**
 * @hidden
 */
let LocalizedMessagesDirective = LocalizedMessagesDirective_1 = class LocalizedMessagesDirective extends ComponentMessages {
    constructor(service) {
        super();
        this.service = service;
    }
};
LocalizedMessagesDirective.ɵfac = function LocalizedMessagesDirective_Factory(t) { return new (t || LocalizedMessagesDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.LocalizationService)); };
LocalizedMessagesDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: LocalizedMessagesDirective, selectors: [["", "kendoNotificationLocalizedMessages", ""]], inputs: { closeTitle: "closeTitle" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: ComponentMessages,
                useExisting: forwardRef(() => LocalizedMessagesDirective_1)
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
__decorate([
    Input(),
    __metadata("design:type", String)
], LocalizedMessagesDirective.prototype, "closeTitle", void 0);
LocalizedMessagesDirective = LocalizedMessagesDirective_1 = __decorate([ __metadata("design:paramtypes", [LocalizationService])
], LocalizedMessagesDirective);

/**
 * Represents the [NgModule]({{ site.data.urls.angular['ngmoduleapi'] }})
 * definition for the Notification component.
 *
 * The package exports:
 * - `NotificationService`&mdash;The Notification service class.
 *
 * @example
 *
 * ```ts-no-run
 * // Import the Notification module
 * import { NotificationModule } from '@progress/kendo-angular-notification';
 *
 * // The browser platform with a compiler
 * import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
 *
 * import { NgModule } from '@angular/core';
 *
 * // Import the app component
 * _@NgModule{{
 *    declarations: [AppComponent], // declare app component
 *    imports:      [BrowserModule, NotificationModule], // import NotificationModule module
 *    bootstrap:    [AppComponent]
 * }}
 * export class AppModule {}
 *
 * // Compile and launch the module
 * platformBrowserDynamic().bootstrapModule(AppModule);
 * ```
 */
let NotificationModule = class NotificationModule {
};
NotificationModule.ɵfac = function NotificationModule_Factory(t) { return new (t || NotificationModule)(); };
NotificationModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NotificationModule });
NotificationModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [NotificationService], imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NotificationComponent, [{
        type: Component,
        args: [{
                selector: 'kendo-notification',
                template: `
    <ng-container kendoNotificationLocalizedMessages
        i18n-closeTitle="kendo.notification.closeTitle|The title of the close button"
        closeTitle="Close"
    >
    </ng-container>
    <div class="k-widget k-notification {{ notificationClasses() }}"
        [ngClass]="cssClass"
        [style.height.px]="height"
        [style.width.px]="width">
        <div class="k-notification-wrap k-hstack">
            <span *ngIf="type && type.icon && type.style !== 'none'" class="k-icon" [ngClass]="typeIconClass()"></span>

            <div class="k-notification-content">
                <ng-template
                    [ngIf]="templateRef"
                    [ngTemplateOutlet]="templateRef">
                </ng-template>
                <ng-template
                    [ngIf]="templateString">
                    {{ templateString }}
                </ng-template>
                <ng-container #container></ng-container>
            </div>

            <a *ngIf="closable" class="k-icon k-i-close" [attr.title]="closeButtonTitle" (click)="onCloseClick()"></a>
        </div>
    </div>
  `,
                providers: [
                    LocalizationService,
                    {
                        provide: L10N_PREFIX,
                        useValue: 'kendo.notification'
                    }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc1.AnimationBuilder }, { type: ɵngcc2.LocalizationService }]; }, { width: [{
            type: Input
        }], height: [{
            type: Input
        }], direction: [{
            type: HostBinding,
            args: ['attr.dir']
        }], containerClass: [{
            type: HostBinding,
            args: ['class.k-notification-container']
        }], container: [{
            type: ViewChild,
            args: ['container', { read: ViewContainerRef, static: true }]
        }], templateRef: [{
            type: Input
        }], templateString: [{
            type: Input
        }], cssClass: [{
            type: Input
        }], hideAfter: [{
            type: Input
        }], closable: [{
            type: Input
        }], type: [{
            type: Input
        }], animation: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NotificationContainerComponent, [{
        type: Component,
        args: [{
                selector: 'kendo-notification-container',
                template: `
    <div #group class="k-notification-group">
        <ng-container #container></ng-container>
    </div>
  `
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ComponentFactoryResolver }]; }, { id: [{
            type: Input
        }], container: [{
            type: ViewChild,
            args: ['container', { read: ViewContainerRef, static: true }]
        }], group: [{
            type: ViewChild,
            args: ['group', { static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NotificationService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.Injector }, { type: ɵngcc0.ElementRef, decorators: [{
                type: Inject,
                args: [NOTIFICATION_CONTAINER]
            }, {
                type: Optional
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LocalizedMessagesDirective, [{
        type: Directive,
        args: [{
                providers: [
                    {
                        provide: ComponentMessages,
                        useExisting: forwardRef(() => LocalizedMessagesDirective_1)
                    }
                ],
                selector: `[kendoNotificationLocalizedMessages]`
            }]
    }], function () { return [{ type: ɵngcc2.LocalizationService }]; }, { closeTitle: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NotificationModule, [{
        type: NgModule,
        args: [{
                declarations: [NotificationComponent, NotificationContainerComponent, LocalizedMessagesDirective],
                entryComponents: [NotificationComponent, NotificationContainerComponent],
                imports: [CommonModule],
                exports: [NotificationComponent, NotificationContainerComponent],
                providers: [NotificationService]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NotificationModule, { declarations: function () { return [NotificationComponent, NotificationContainerComponent, LocalizedMessagesDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [NotificationComponent, NotificationContainerComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { LocalizedMessagesDirective, NotificationContainerComponent, NotificationSettings, NotificationComponent, NotificationService, NOTIFICATION_CONTAINER, NotificationModule };

